import {scriptonload} from '../modules/scriptonload';

class YaShare2 {
    constructor(wrapper){
        this.param = JSON.parse(wrapper.getAttribute('data-param'));
        this.wrapper = wrapper;
        this.frame = this.param.type ? wrapper.querySelector('[data-YaShare2-wrapper]') : wrapper;
        this._add();
    }

    _add(){
        var self = this;
        scriptonload(['//yastatic.net/es5-shims/0.0.2/es5-shims.min.js', '//yastatic.net/share2/share.js'], function(){
            self._create.call(self);
        });
    }

    _create(){
        var self =this;

        Ya.share2(this.frame, {
            content: {
                url: this.param.url,
                image: this.param.image
            },
            theme: {
                services: 'vkontakte,facebook,odnoklassniki,twitter',
                bare:true,
                counter:true
            },
            hooks: {
                onready: function () {
                    if(self.param.type==='counter') self._showCounter.call(self);
                }
            }
        });
    }

    _showCounter(){
        var num = this.wrapper.querySelector('[data-YaShare2-num]'),
            all = this.frame.querySelectorAll('.ya-share2__counter'),
            all2 = this.wrapper.querySelectorAll('.ya-share2__counter'),
            countAll = 0,
            check = function(){
                for(var i=0,j=all.length; i<j; i++){
                    var inner = all[i].innerHTML;
                    if(!inner.length){
                        requestAnimationFrame(check);
                        countAll = 0;
                        return false;
                    }

                    var count = parseFloat(inner);
                    countAll += count;
                }

                // 0 не выводим
                if(countAll) num.innerHTML = countAll;
            };

        //количество голосов загружается асинхронно, специального события нет, поэтому отслеживаем сами, когда выставятся все счетчики
        check();
    }
}

export {YaShare2};


